import React from "react";
import { useTranslation } from "react-i18next";
import {
  HiOutlineUserAdd,
  HiOutlineFilter,
  HiOutlineChatAlt2,
  HiOutlineSwitchHorizontal,
} from "react-icons/hi";
import GettingStarted from "../../../molecules/GettingStarted";

const LeadsGettingStarted: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <HiOutlineUserAdd size={22} />,
      title: t("leads.gettingStarted.steps.step1.title") as string,
      body: t("leads.gettingStarted.steps.step1.body") as string,
      mockup: (
        <div className="mt-3 bg-white border border-gray-200 rounded-md p-3 overflow-hidden">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded bg-blue-600 text-white text-xs font-medium">
            <HiOutlineUserAdd size={13} />
            {t("leads.gettingStarted.steps.step1.addButton")}
          </div>
        </div>
      ),
      tip: t("leads.gettingStarted.steps.step1.tip") as string,
    },
    {
      icon: <HiOutlineChatAlt2 size={22} />,
      title: t("leads.gettingStarted.steps.step2.title") as string,
      body: t("leads.gettingStarted.steps.step2.body") as string,
      mockup: (
        <div className="mt-3 bg-white border border-gray-200 rounded-md p-3 overflow-hidden">
          <div className="flex items-center justify-between gap-2">
            <span className="text-xs text-gray-600 font-medium truncate">
              {t("leads.gettingStarted.steps.step2.mockupName")}
            </span>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-amber-100 text-amber-800 text-xs font-semibold flex-shrink-0">
              <HiOutlineFilter size={11} />
              {t("leads.gettingStarted.steps.step2.mockupStatus")}
            </span>
          </div>
        </div>
      ),
    },
    {
      icon: <HiOutlineSwitchHorizontal size={22} />,
      title: t("leads.gettingStarted.steps.step3.title") as string,
      body: t("leads.gettingStarted.steps.step3.body") as string,
      tip: (
        <>
          <span className="block">
            {t("leads.gettingStarted.steps.step3.tipProspect")}
          </span>
          <span className="block">
            {t("leads.gettingStarted.steps.step3.tipCustomer")}
          </span>
        </>
      ),
    },
  ];

  return (
    <GettingStarted
      icon={<HiOutlineFilter className="w-6 h-6 sm:w-7 sm:h-7" />}
      title={t("leads.gettingStarted.title") as string}
      subtitle={t("leads.gettingStarted.subtitle") as string}
      steps={steps}
    />
  );
};

export default LeadsGettingStarted;
